export default {
  name: 'job_editor_content',
  props: {
    parsed_document: Object,
    parsed_active_section: String,
  },
  data() {
    return {
      local_document: null,
    };
  },
  watch: {
    parsed_document: {
      handler(new_val) {
        if (new_val) {
          this.local_document = JSON.parse(JSON.stringify(new_val));
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    update_field() {
      this.$emit('update', this.local_document);
    },
    remove_function(index) {
      this.local_document.main_functions.splice(index, 1);
      this.update_field();
    },
    add_function() {
      if (!this.local_document.main_functions) {
        this.local_document.main_functions = [];
      }
      this.local_document.main_functions.push('');
      this.update_field();
    },
  },
};
